<div class="overflow-x-auto rounded-xl border border-gray-200 bg-white shadow-sm">
  <table class="w-full min-w-[1400px] border-collapse ltr:text-left rtl:text-right">
    <thead class="bg-surface-subtle border-b border-gray-200">
      <tr>
        <th class="w-10 px-2 py-3 text-center text-[12px] font-bold text-gray-500">#</th>

        @if (!productId()) {
          <th class="px-3 py-3 text-[12px] font-bold text-gray-500" i18n="@@stock.colProduct">Product</th>
        }

        <th class="px-3 py-3 text-[12px] font-bold text-gray-500" i18n="@@stock.colType">Stock Type</th>
        <th class="px-3 py-3 text-[12px] font-bold text-gray-500" i18n="@@stock.colMfgExp">MFG / Expiry Date</th>
        <th class="px-3 py-3 text-center text-[12px] font-bold text-gray-500" i18n="@@stock.Batch">Batch No.</th>
        <th class="px-3 py-3 text-[12px] font-bold text-gray-500" i18n="@@stock.colSupplier">Supplier</th>
        <th class="px-3 py-3 text-center text-[12px] font-bold text-gray-500" i18n="@@stock.Seller">
          Seller Price & Discount
        </th>
        <th class="px-3 py-3 text-center text-[12px] font-bold text-gray-500" i18n="@@stock.Pharmacy">
          Pharmacy Price & Discount
        </th>
        <th class="px-3 py-3 text-center text-[12px] font-bold text-gray-500" i18n="@@stock.colPeoplePrice">
          People Price
        </th>
        <th class="px-3 py-3 text-center text-[12px] font-bold text-gray-500" i18n="@@stock.colQty">
          Available/ Total Quantity
        </th>
        <th class="px-3 py-3 text-[12px] font-bold text-gray-500" i18n="@@stock.colCreated">Creation On / By</th>
        <th class="px-6 py-4 text-center text-[11px] font-bold text-gray-500 uppercase"></th>
      </tr>
    </thead>
    <tbody class="divide-y divide-gray-100">
      <!-- @for (item of allStockData(); track $index) { -->
      @for (item of displayData(); track $index) {
        <tr class="transition-colors hover:bg-gray-50">
          <td class="px-2 py-4 text-center text-[12px] font-medium text-gray-500">{{ startItem() + $index }}</td>

          @if (!productId()) {
            <td class="px-3 py-4">
              <div class="max-w-[200px] truncate text-[12px] font-bold text-gray-800">
                {{ getTranslatedTitle(item.product) }}
              </div>
            </td>
          }

          <td class="px-3 py-4 text-center">
            <span
              class="inline-flex min-w-[100px] items-center justify-center rounded-full border border-blue-100 bg-blue-50 px-2 py-1 text-[10px] font-bold text-blue-700">
              {{ getTranslatedTitle(item.stockType) }}
            </span>
          </td>

          <td class="px-3 py-4">
            <div class="flex flex-col text-[11px] leading-tight font-bold tabular-nums">
              <span class="text-green-600">{{ mfgLabel() }} {{ item.mfgDate | date: "MM/yyyy" }}</span>
              <span
                [ngClass]="{ 'text-red-600': isExpired(item.expDate), 'text-orange-500': isNearExpiry(item.expDate) }">
                {{ expLabel() }} {{ item.expDate | date: "MM/yyyy" }}
              </span>
            </div>
          </td>
          <td class="px-3 py-4 text-center text-[12px] text-gray-600">{{ item.batchNumber }}</td>

          <td class="px-3 py-4 text-[12px] text-gray-600">{{ getTranslatedTitle(item.supplier) || "---" }}</td>

          <td class="px-3 py-4 text-center text-[13px]">
            <div class="font-bold">{{ item.sellerPrice }} {{ currency() }}</div>
            @if (item.sellerPriceDiscountPercentage) {
              <div class="text-[10px] font-bold text-red-500">
                @if (isAr()) {
                  {{ discountLabel() }} {{ item.sellerPriceDiscountPercentage }}%
                } @else {
                  {{ item.sellerPriceDiscountPercentage }}% {{ discountLabel() }}
                }
              </div>
            }
          </td>

          <td class="px-3 py-4 text-center text-[13px]">
            <div class="font-bold">{{ item.pharmacyPrice }} {{ currency() }}</div>
            @if (item.pharmacyPriceDiscountPercentage) {
              <div class="text-[10px] font-bold text-red-500">
                @if (isAr()) {
                  {{ discountLabel() }} {{ item.pharmacyPriceDiscountPercentage }}%
                } @else {
                  {{ item.pharmacyPriceDiscountPercentage }}% {{ discountLabel() }}
                }
              </div>
            }
          </td>

          <td class="px-3 py-4 text-center font-bold text-gray-800">
            {{ item.peoplePrice }}
            <span class="text-[10px] font-medium">{{ currency() }}</span>
          </td>

          <td class="text-primary px-3 py-4 text-center font-bold">{{ item.quantity }}</td>

          <td class="px-3 py-4">
            <div class="flex flex-col leading-tight">
              <span class="text-[11px] font-bold text-gray-800">{{ item.createdBy?.fullName }}</span>
              <span class="text-[9px] text-gray-400">{{ item.createdOn | date }}</span>
            </div>
          </td>

          <td class="px-6 py-4 text-center">
            <button class="hover-text-primary cursor-pointer text-gray-400">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round">
                <circle cx="12" cy="12" r="1" />
                <circle cx="12" cy="5" r="1" />
                <circle cx="12" cy="19" r="1" />
              </svg>
            </button>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>

<div
  class="mt-4 flex flex-col items-center justify-between gap-4 rounded-lg border border-gray-200 bg-gray-50 p-4 sm:flex-row"
  [dir]="isAr() ? 'rtl' : 'ltr'">
  <div class="flex items-center gap-3">
    <span class="text-[13px] text-gray-500">{{ isAr() ? "عناصر لكل صفحة:" : "Items per page:" }}</span>
    <select
      [value]="itemsPerPage()"
      (change)="onPageSizeChange($event)"
      class="focus-ring-primary rounded-md border border-gray-300 bg-white px-2 py-1 text-[13px] outline-none focus:ring-1">
      <option [value]="25">25</option>
      <option [value]="50">50</option>
      <option [value]="100">100</option>
    </select>
    <div class="ms-4 text-[13px] text-gray-600 tabular-nums">
      {{ isAr() ? "عرض" : "Showing" }}
      <span class="text-primary mx-1 font-bold">{{ getStartItem() }}-{{ getEndItem() }}</span>
      {{ isAr() ? "من" : "of" }}
      <span class="text-primary mx-1 font-bold">{{ totalItems() }}</span>
    </div>
  </div>

  <div class="flex items-center gap-1">
    <button
      (click)="previousPage.emit()"
      [disabled]="currentPage() === 1"
      class="flex h-8 w-8 items-center justify-center rounded border border-gray-300 bg-white transition-all hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-30">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        class="rtl:rotate-180">
        <polyline points="15 18 9 12 15 6"></polyline>
      </svg>
    </button>

    @for (page of getPageNumbers(); track $index) {
      @if (page === -1) {
        <span class="px-2 text-gray-400">...</span>
      } @else {
        <button
          (click)="goToPage.emit(page)"
          [class]="
            currentPage() === page
              ? 'bg-primary border-primary text-white'
              : 'border-gray-300 bg-white text-gray-600 hover:bg-gray-50'
          "
          class="h-8 w-8 rounded border text-[13px] font-bold tabular-nums transition-all">
          {{ page }}
        </button>
      }
    }

    <button
      (click)="nextPage.emit()"
      [disabled]="currentPage() === totalPages()"
      class="flex h-8 w-8 items-center justify-center rounded border border-gray-300 bg-white transition-all hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-30">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        class="rtl:rotate-180">
        <polyline points="9 18 15 12 9 6"></polyline>
      </svg>
    </button>
  </div>
</div>
